import { useEffect, useMemo, useState } from "react";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Paper from "@mui/material/Paper";
import Icon from "@mui/material/Icon";
import Draggable from "react-draggable";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import PageHeader from "pages/components/PageHeader";
import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import { abrirRelatorio } from "pages/utils/abrirRelatorio";

function PaperComponent(props) {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], [class*="MuiDialogActions-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function EmailsFaturacaoClientes() {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [grupoSel, setGrupoSel] = useState(null);

  const obterMesAnterior = () => {
    const hoje = new Date();

    const primeiroDiaMesAtual = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    const ultimoDiaMesAnterior = new Date(primeiroDiaMesAtual.getTime() - 1);

    const primeiroDiaMesAnterior = new Date(
      ultimoDiaMesAnterior.getFullYear(),
      ultimoDiaMesAnterior.getMonth(),
      1
    );

    const formatarData = (data) => {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");

      return `${ano}-${mes}-${dia}`;
    };

    return {
      dataIni: formatarData(primeiroDiaMesAnterior),
      dataFim: formatarData(ultimoDiaMesAnterior),
    };
  };

  const periodoInicial = obterMesAnterior();

  const [dataIni, setDataIni] = useState(periodoInicial.dataIni);
  const [dataFim, setDataFim] = useState(periodoInicial.dataFim);

  const [openUltimosEnvios, setOpenUltimosEnvios] = useState(false);
  const [ultimosEnvios, setUltimosEnvios] = useState([]);
  const [loadingUltimosEnvios, setLoadingUltimosEnvios] = useState(false);

  const [openPreview, setOpenPreview] = useState(false);
  const [preview, setPreview] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);

  const [openDocumentoDetalhe, setOpenDocumentoDetalhe] = useState(false);
  const [documentoDetalhe, setDocumentoDetalhe] = useState(null);
  const [loadingDocumentoDetalhe, setLoadingDocumentoDetalhe] = useState(false);

  const [loadingExcelDocumento, setLoadingExcelDocumento] = useState(false);
  const [loadingExcelPeriodo, setLoadingExcelPeriodo] = useState(false);
  const [loadingPdfDocumento, setLoadingPdfDocumento] = useState(false);
  const [loadingListaSap, setLoadingListaSap] = useState(false);
  const [openInstrucoesSap, setOpenInstrucoesSap] = useState(false);

  useEffect(() => {
    const carregar = async () => {
      setLoading(true);

      const [data, err] = await handleApi(api.post("EmailsFaturacaoClientes/SelGrupos", {}));

      setLoading(false);

      if (err) {
        showAlert(err, "error");
        return;
      }

      setGrupos(Array.isArray(data) ? data : []);
    };

    carregar();
  }, [showAlert]);

  const selecionarGrupo = (grupo) => {
    setGrupoSel(grupo);
  };

  const refsTexto = useMemo(() => {
    const refs = grupoSel?.refclientes;
    if (!Array.isArray(refs) || refs.length === 0) return "";
    return refs.join(", ");
  }, [grupoSel]);

  const abrirPreview = async () => {
    if (!grupoSel?.grupo) {
      showAlert("Selecione um grupo.", "warning");
      return;
    }

    if (!dataIni || !dataFim) {
      showAlert("Indique a data inicial e a data final.", "warning");
      return;
    }

    if (dataFim < dataIni) {
      showAlert("A data final não pode ser anterior à data inicial.", "warning");
      return;
    }

    setOpenPreview(true);
    setLoadingPreview(true);
    setPreview(null);

    const [data, err, meta] = await handleApi(
      api.post("EmailsFaturacaoClientes/SelResumoDocumentos", {
        grupo: grupoSel.grupo,
        dataini: dataIni,
        datafim: dataFim,
      })
    );

    setLoadingPreview(false);

    if (err) {
      setOpenPreview(false);
      showAlert(err, "error");
      return;
    }

    if (meta?.success === false) {
      setOpenPreview(false);
      showAlert(meta?.message ?? "Não foi possível obter a pré-visualização.", "error");
      return;
    }

    setPreview(data);
  };

  const abrirDocumentoDetalhe = async (row) => {
    if (!grupoSel?.grupo || !row?.faturanumero) return;

    setOpenDocumentoDetalhe(true);
    setDocumentoDetalhe(null);
    setLoadingDocumentoDetalhe(true);

    const [data, err, meta] = await handleApi(
      api.post("EmailsFaturacaoClientes/SelDocumentoDetalhe", {
        grupo: grupoSel.grupo,
        faturanumero: row.faturanumero,
        dataini: dataIni,
      })
    );

    setLoadingDocumentoDetalhe(false);

    if (err) {
      setOpenDocumentoDetalhe(false);
      showAlert(err, "error");
      return;
    }

    if (meta?.success === false) {
      setOpenDocumentoDetalhe(false);
      showAlert(meta?.message ?? "Não foi possível obter o detalhe do documento.", "error");
      return;
    }

    setDocumentoDetalhe(data);
  };

  const gerarExcelDocumento = async () => {
    const faturaNumero = documentoDetalhe?.cabecalho?.faturaNumero;

    if (!grupoSel?.grupo || !faturaNumero) {
      showAlert("Não foi possível identificar o documento.", "warning");
      return;
    }

    try {
      setLoadingExcelDocumento(true);

      const res = await api({
        url: "EmailsFaturacaoClientes/GerarExcelDocumento",
        method: "post",
        data: {
          grupo: grupoSel.grupo,
          faturanumero: faturaNumero,
          dataini: dataIni,
        },
        responseType: "arraybuffer",
      });

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `Faturacao_${faturaNumero}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar Excel.", "error");
    } finally {
      setLoadingExcelDocumento(false);
    }
  };

  const gerarPdfDocumento = async () => {
    const faturaNumero = documentoDetalhe?.cabecalho?.faturaNumero;

    if (!grupoSel?.grupo || !faturaNumero) {
      showAlert("Não foi possível identificar o documento.", "warning");
      return;
    }

    try {
      setLoadingPdfDocumento(true);

      const [data, err, meta] = await handleApi(
        api.post("EmailsFaturacaoClientes/GerarPdfDocumento", {
          grupo: grupoSel.grupo,
          faturanumero: faturaNumero,
          dataini: dataIni,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      if (meta?.success === false) {
        showAlert(meta?.message ?? "Não foi possível gerar o PDF.", "error");
        return;
      }

      const url = data?.url ?? data?.data?.url ?? data?.data ?? data;

      if (!url) {
        showAlert("Não foi possível obter o URL do PDF.", "error");
        return;
      }

      abrirRelatorio(url);
    } catch (err) {
      showAlert("Erro ao gerar PDF.", "error");
    } finally {
      setLoadingPdfDocumento(false);
    }
  };

  const gerarListaSap = async () => {
    if (!grupoSel?.grupo) {
      showAlert("Selecione um grupo.", "warning");
      return;
    }

    if (!dataIni || !dataFim) {
      showAlert("Indique a data inicial e a data final.", "warning");
      return;
    }

    if (dataFim < dataIni) {
      showAlert("A data final não pode ser anterior à data inicial.", "warning");
      return;
    }

    try {
      setLoadingListaSap(true);

      const res = await api({
        url: "EmailsFaturacaoClientes/GerarListaSap",
        method: "post",
        data: {
          grupo: grupoSel.grupo,
          dataini: dataIni,
          datafim: dataFim,
        },
        responseType: "arraybuffer",
      });

      const contentType = res.headers["content-type"] || "";

      if (contentType.includes("application/json")) {
        const texto = new TextDecoder("utf-8").decode(res.data);

        let resposta;

        try {
          resposta = JSON.parse(texto);
        } catch {
          resposta = null;
        }

        if (resposta?.success === false) {
          showAlert(resposta?.message ?? "Não foi possível gerar a lista SAP.", "warning");
          return;
        }
      }

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = "SAP_Documentos.txt";

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);

      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "text/plain;charset=utf-8",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Lista SAP gerada com sucesso.", "success");
      setOpenInstrucoesSap(true);
    } catch (err) {
      showAlert("Erro ao gerar lista SAP.", "error");
    } finally {
      setLoadingListaSap(false);
    }
  };

  const gerarExcelPeriodo = async () => {
    if (!grupoSel?.grupo) {
      showAlert("Selecione um grupo.", "warning");
      return;
    }

    if (!dataIni || !dataFim) {
      showAlert("Indique a data inicial e a data final.", "warning");
      return;
    }

    if (dataFim < dataIni) {
      showAlert("A data final não pode ser anterior à data inicial.", "warning");
      return;
    }

    try {
      setLoadingExcelPeriodo(true);

      const res = await api({
        url: "EmailsFaturacaoClientes/GerarExcelPeriodo",
        method: "post",
        data: {
          grupo: grupoSel.grupo,
          dataini: dataIni,
          datafim: dataFim,
        },
        responseType: "arraybuffer",
      });

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `Faturacao_${grupoSel.grupo}_${dataIni.replaceAll(
        "-",
        ""
      )}_${dataFim.replaceAll("-", "")}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel do período gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar Excel do período.", "error");
    } finally {
      setLoadingExcelPeriodo(false);
    }
  };

  const abrirUltimosEnvios = async () => {
    setOpenUltimosEnvios(true);
    setLoadingUltimosEnvios(true);

    const [data, err] = await handleApi(api.post("EmailsFaturacaoClientes/SelUltimosEnvios", {}));

    setLoadingUltimosEnvios(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setUltimosEnvios(Array.isArray(data) ? data : []);
  };

  const formatarData = (valor) => {
    if (!valor) return "";

    const [ano, mes, dia] = String(valor).split("-");
    if (!ano || !mes || !dia) return valor;

    return `${dia}/${mes}/${ano}`;
  };

  const formatarDataHora = (valor) => {
    if (!valor) return "";

    const [data, hora] = String(valor).split(" ");

    if (!data) return valor;

    return `${formatarData(data)}${hora ? ` ${hora.substring(0, 5)}` : ""}`;
  };

  const prepararEmail = () => {
    if (!grupoSel?.grupo) {
      showAlert("Selecione um grupo.", "warning");
      return;
    }

    if (!dataIni || !dataFim) {
      showAlert("Indique a data inicial e a data final.", "warning");
      return;
    }

    if (dataFim < dataIni) {
      showAlert("A data final não pode ser anterior à data inicial.", "warning");
      return;
    }

    const params = new URLSearchParams({
      grupo: grupoSel.grupo,
      dataini: dataIni,
      datafim: dataFim,
    });

    window.open(
      `/emails-faturacao-clientes/preparar?${params.toString()}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const previewColumns = useMemo(
    () => [
      {
        Header: "Data",
        accessor: "faturadata",
        width: 110,
        Cell: ({ value }) => formatarData(value),
      },
      {
        Header: "Documento",
        accessor: "faturanumero",
        width: 140,
      },
      {
        Header: "Tipo",
        accessor: "tipo",
        width: 160,
      },
      {
        Header: "Cliente",
        id: "cliente",
        accessor: (row) => (row.cliente ? `${row.cliente} - ${row.refcliente}` : row.refcliente),
        width: 260,
      },
      {
        Header: "Pagador",
        id: "pagador",
        accessor: (row) => (row.pagador ? `${row.pagador} - ${row.refpagador}` : row.refpagador),
        width: 260,
      },
      {
        Header: "Linhas",
        accessor: "qtd_linhas",
        width: 90,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Docs. estorno",
        accessor: "qtd_estornos",
        width: 90,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Linhas estorno",
        accessor: "qtd_linhas_estorno",
        width: 120,
        align: "right",
        sortType: "numPt",
      },
    ],
    []
  );

  const previewRowActions = useMemo(
    () => [
      {
        id: "detalhe",
        icon: <Icon fontSize="small">info</Icon>,
        tooltip: "Ver detalhe do documento",
        color: "info",
        onClick: abrirDocumentoDetalhe,
      },
    ],
    [grupoSel, dataIni]
  );

  const ultimosEnviosColumns = useMemo(
    () => [
      {
        Header: "Enviado em",
        accessor: "enviadoem",
        width: 150,
        Cell: ({ value }) => formatarDataHora(value),
      },
      {
        Header: "Grupo",
        accessor: "grupo",
        width: 130,
      },
      {
        Header: "Período",
        id: "periodo",
        accessor: (row) => `${formatarData(row.dataini)} a ${formatarData(row.datafim)}`,
        width: 220,
      },
      {
        Header: "Tipo",
        accessor: "tipoenvio",
        width: 120,
      },
      {
        Header: "Para",
        accessor: "destinatarios",
        width: 260,
      },
      {
        Header: "Cc",
        accessor: "cc",
        width: 220,
      },
      {
        Header: "Formatos",
        accessor: "formatos",
        width: 120,
      },
      {
        Header: "Documentos",
        accessor: "qtd_documentos",
        width: 110,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Utilizador",
        accessor: "criadopor",
        width: 160,
      },
    ],
    []
  );

  const detalheColumns = useMemo(
    () => [
      {
        Header: "Material",
        accessor: "refmaterial",
        width: 120,
      },
      {
        Header: "Descrição",
        accessor: "material",
        width: 320,
      },
      {
        Header: "Qtd",
        accessor: "qtd",
        width: 90,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Un.",
        accessor: "qtdunid",
        width: 80,
      },
      {
        Header: "Preço",
        accessor: "precoaconselhado",
        width: 110,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Desc. Com. %",
        accessor: "desccomperc",
        width: 110,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Desc. Prom. %",
        accessor: "descpromperc",
        width: 120,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Líquido",
        accessor: "precoliquido",
        width: 110,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "IVA %",
        accessor: "ivaperc",
        width: 90,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "IVA",
        accessor: "ivavalor",
        width: 100,
        align: "right",
        sortType: "numPt",
      },
      {
        Header: "Total",
        accessor: "precocomiva",
        width: 110,
        align: "right",
        sortType: "numPt",
      },
    ],
    []
  );

  const estornosColumns = useMemo(
    () => [
      {
        Header: "Documento estorno",
        accessor: "faturanumero",
        width: 150,
      },
      {
        Header: "Data",
        accessor: "faturadata",
        width: 110,
        Cell: ({ value }) => formatarData(value),
      },
      ...detalheColumns,
    ],
    [detalheColumns]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox mt={3}>
        <Card>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={grupos}
                  value={grupoSel}
                  onChange={(_, value) => selecionarGrupo(value)}
                  getOptionLabel={(option) => option?.grupo ?? ""}
                  isOptionEqualToValue={(option, value) => option?.grupo === value?.grupo}
                  renderInput={(params) => <TextField {...params} label="Grupo" size="small" />}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Data inicial"
                  value={dataIni}
                  onChange={(e) => setDataIni(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Data final"
                  value={dataFim}
                  onChange={(e) => setDataFim(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {grupoSel && (
                <Grid item xs={12}>
                  <MDTypography variant="caption">
                    Clientes: {refsTexto || "Sem referências configuradas"}
                  </MDTypography>
                </Grid>
              )}

              <Grid item xs={12}>
                <MDBox
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  gap={1}
                  justifyContent="flex-start"
                >
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={abrirPreview}
                    disabled={loading}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Icon sx={{ mr: 1 }}>visibility</Icon>
                    Pré-visualizar
                  </MDButton>

                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={abrirUltimosEnvios}
                    disabled={loading}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Icon sx={{ mr: 1 }}>history</Icon>
                    Últimos envios
                  </MDButton>

                  <MDButton
                    color="warning"
                    variant="outlined"
                    onClick={gerarListaSap}
                    disabled={loading || loadingListaSap || loadingExcelPeriodo}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    {loadingListaSap ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <Icon sx={{ mr: 1 }}>description</Icon>
                        Gerar lista SAP
                      </>
                    )}
                  </MDButton>

                  <MDButton
                    color="success"
                    variant="outlined"
                    onClick={gerarExcelPeriodo}
                    disabled={loading || loadingExcelPeriodo || loadingListaSap}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    {loadingExcelPeriodo ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <Icon sx={{ mr: 1 }}>table_view</Icon>
                        Gerar Excel
                      </>
                    )}
                  </MDButton>
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                <MDBox
                  display="flex"
                  justifyContent={{ xs: "stretch", sm: "flex-end" }}
                  sx={{
                    "& > button": {
                      width: { xs: "100%", sm: "auto" },
                    },
                  }}
                >
                  <MDButton
                    color="success"
                    variant="gradient"
                    onClick={prepararEmail}
                    disabled={loading}
                  >
                    <Icon sx={{ mr: 1 }}>mail</Icon>
                    Preparar e-mail
                  </MDButton>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>

      <Dialog
        open={openInstrucoesSap}
        onClose={() => setOpenInstrucoesSap(false)}
        PaperComponent={PaperComponent}
        fullWidth
        maxWidth="sm"
        aria-labelledby="dialog-instrucoes-sap-title"
        PaperProps={{
          sx: {
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            m: { xs: 1, sm: 2 },
          },
        }}
      >
        <DialogTitle
          id="dialog-instrucoes-sap-title"
          className="draggable-dialog-title"
          sx={{
            cursor: "move",
            fontWeight: 600,
            pr: 6,
          }}
        >
          Próximo passo — gerar documentos no SAP
        </DialogTitle>

        <DialogContent dividers>
          <MDTypography variant="body2" mb={2}>
            O ficheiro <strong>SAP_Documentos.txt</strong> foi preparado para download.
          </MDTypography>

          <MDTypography variant="body2" mb={2}>
            Confirme primeiro a gravação desse ficheiro na pasta de Transferências.
          </MDTypography>

          <MDTypography variant="body2" mb={2}>
            De seguida, confirme que tem uma sessão iniciada no <strong>UNIDIS</strong>, e execute o
            ficheiro <strong>Gerar_Faturas_SAP_Lote</strong>, que deverá estar disponível no seu
            Ambiente de Trabalho.
          </MDTypography>

          <MDTypography variant="caption" color="text" display="block" mt={2}>
            Este passo é executado fora da JF Gest e irá gerar os documentos PDF oficiais a partir
            do SAP.
          </MDTypography>
        </DialogContent>

        <DialogActions>
          <MDButton color="info" variant="gradient" onClick={() => setOpenInstrucoesSap(false)}>
            Entendido
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        PaperComponent={PaperComponent}
        fullWidth
        maxWidth="lg"
        fullScreen={false}
        aria-labelledby="dialog-preview-title"
        PaperProps={{
          sx: {
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            maxHeight: { xs: "calc(100% - 16px)", sm: "90vh" },
            m: { xs: 1, sm: 2 },
          },
        }}
      >
        <DialogTitle
          id="dialog-preview-title"
          className="draggable-dialog-title"
          sx={{
            fontWeight: 600,
            pr: 6,
          }}
        >
          Pré-visualização da faturação
        </DialogTitle>

        <DialogContent dividers>
          {loadingPreview ? (
            <MDBox py={4} display="flex" alignItems="center" justifyContent="center">
              <CircularProgress />
            </MDBox>
          ) : !preview ? (
            <MDTypography variant="body2">Não foi possível obter a pré-visualização.</MDTypography>
          ) : (
            <>
              <MDBox mb={2}>
                <MDTypography variant="body2">
                  <strong>Cliente:</strong> {preview.grupo}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Período:</strong> {formatarData(preview.dataini)} a{" "}
                  {formatarData(preview.datafim)}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Documentos:</strong> {preview.qtd_documentos}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Estornos associados:</strong> {preview.qtd_estornos}
                </MDTypography>
              </MDBox>

              {!Array.isArray(preview.documentos) || preview.documentos.length === 0 ? (
                <MDTypography variant="body2">
                  Não foram encontrados documentos para o grupo e período selecionados.
                </MDTypography>
              ) : (
                <ProjectTable
                  tableKey="emails-faturacao-clientes-preview"
                  version="v1"
                  columns={previewColumns}
                  data={preview.documentos}
                  rowActions={previewRowActions}
                  loading={false}
                  emptyMessage="Não foram encontrados documentos para o grupo e período selecionados."
                  minWidth={1100}
                  maxHeight="40vh"
                  defaultSortBy={[
                    { id: "faturadata", desc: false },
                    { id: "faturanumero", desc: false },
                  ]}
                />
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <MDButton color="secondary" variant="outlined" onClick={() => setOpenPreview(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDocumentoDetalhe}
        onClose={() => setOpenDocumentoDetalhe(false)}
        fullWidth
        maxWidth="xl"
        PaperComponent={PaperComponent}
        aria-labelledby="dialog-documento-detalhe-title"
        PaperProps={{
          sx: {
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            maxHeight: { xs: "calc(100% - 16px)", sm: "94vh" },
            m: { xs: 1, sm: 2 },
          },
        }}
      >
        <DialogTitle
          id="dialog-documento-detalhe-title"
          className="draggable-dialog-title"
          sx={{
            cursor: "move",
            fontWeight: 600,
          }}
        >
          Detalhe do documento
        </DialogTitle>

        <DialogContent dividers>
          {loadingDocumentoDetalhe ? (
            <MDBox py={4} display="flex" alignItems="center" justifyContent="center">
              <CircularProgress />
            </MDBox>
          ) : !documentoDetalhe ? (
            <MDTypography variant="body2">
              Não foi possível obter o detalhe do documento.
            </MDTypography>
          ) : (
            <>
              <MDBox mb={2}>
                <MDTypography variant="body2">
                  <strong>{documentoDetalhe.cabecalho?.tipo ?? "Documento"}:</strong>{" "}
                  {documentoDetalhe.cabecalho?.faturanumero}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Data:</strong> {formatarData(documentoDetalhe.cabecalho?.faturadata)}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Cliente:</strong> {documentoDetalhe.cabecalho?.cliente} -{" "}
                  {documentoDetalhe.cabecalho?.refcliente}
                </MDTypography>

                <MDTypography variant="body2">
                  <strong>Pagador:</strong> {documentoDetalhe.cabecalho?.pagador} -{" "}
                  {documentoDetalhe.cabecalho?.refpagador}
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <ProjectTable
                  tableKey="emails-faturacao-clientes-detalhe-vendas"
                  version="v1"
                  title="Vendas"
                  columns={detalheColumns}
                  data={Array.isArray(documentoDetalhe.vendas) ? documentoDetalhe.vendas : []}
                  loading={false}
                  emptyMessage="Sem linhas de venda."
                  minWidth={1250}
                  maxHeight="24vh"
                />
              </MDBox>

              <MDBox mb={3}>
                <ProjectTable
                  tableKey="emails-faturacao-clientes-detalhe-vasilhame"
                  version="v1"
                  title="Vasilhame"
                  columns={detalheColumns}
                  data={Array.isArray(documentoDetalhe.vasilhame) ? documentoDetalhe.vasilhame : []}
                  loading={false}
                  emptyMessage="Sem linhas de vasilhame."
                  minWidth={1250}
                  maxHeight="20vh"
                />
              </MDBox>

              <MDBox mb={2}>
                <ProjectTable
                  tableKey="emails-faturacao-clientes-detalhe-estornos"
                  version="v1"
                  title="Estornos"
                  columns={estornosColumns}
                  data={Array.isArray(documentoDetalhe.estornos) ? documentoDetalhe.estornos : []}
                  loading={false}
                  emptyMessage="Sem estornos associados."
                  minWidth={1450}
                  maxHeight="24vh"
                />
              </MDBox>

              <MDBox
                display="flex"
                justifyContent="flex-end"
                sx={{
                  width: "100%",
                }}
              >
                <MDBox
                  sx={{
                    width: { xs: "100%", sm: 360 },
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                    <MDTypography variant="body2">Vendas</MDTypography>
                    <MDTypography variant="body2">
                      {Number(documentoDetalhe.totais?.vendas ?? 0).toLocaleString("pt-PT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      €
                    </MDTypography>
                  </MDBox>

                  <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                    <MDTypography variant="body2">Vasilhame</MDTypography>
                    <MDTypography variant="body2">
                      {Number(documentoDetalhe.totais?.vasilhame ?? 0).toLocaleString("pt-PT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      €
                    </MDTypography>
                  </MDBox>

                  <MDBox display="flex" justifyContent="space-between" mb={1}>
                    <MDTypography variant="body2">Estornos</MDTypography>
                    <MDTypography variant="body2">
                      {Number(documentoDetalhe.totais?.estornos ?? 0).toLocaleString("pt-PT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      €
                    </MDTypography>
                  </MDBox>

                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    pt={1}
                    borderTop="1px solid #d0d0d0"
                  >
                    <MDTypography variant="subtitle2" fontWeight="bold">
                      Total final
                    </MDTypography>

                    <MDTypography variant="subtitle2" fontWeight="bold">
                      {Number(documentoDetalhe.totais?.documento ?? 0).toLocaleString("pt-PT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      €
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            flexDirection: { xs: "column-reverse", sm: "row" },
            gap: 1,
            "& > button": {
              width: { xs: "100%", sm: "auto" },
            },
          }}
        >
          <MDButton
            color="error"
            variant="outlined"
            onClick={gerarPdfDocumento}
            disabled={
              loadingPdfDocumento ||
              loadingExcelDocumento ||
              loadingDocumentoDetalhe ||
              !documentoDetalhe
            }
          >
            {loadingPdfDocumento ? (
              <CircularProgress size={18} />
            ) : (
              <>
                <Icon sx={{ mr: 1 }}>picture_as_pdf</Icon>
                Gerar PDF
              </>
            )}
          </MDButton>

          <MDButton
            color="info"
            variant="outlined"
            onClick={gerarExcelDocumento}
            disabled={
              loadingExcelDocumento ||
              loadingPdfDocumento ||
              loadingDocumentoDetalhe ||
              !documentoDetalhe
            }
          >
            {loadingExcelDocumento ? (
              <CircularProgress size={18} />
            ) : (
              <>
                <Icon sx={{ mr: 1 }}>table_view</Icon>
                Gerar Excel
              </>
            )}
          </MDButton>

          <MDButton
            color="secondary"
            variant="outlined"
            onClick={() => setOpenDocumentoDetalhe(false)}
            disabled={loadingExcelDocumento || loadingPdfDocumento}
          >
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openUltimosEnvios}
        onClose={() => setOpenUltimosEnvios(false)}
        fullWidth
        maxWidth="xl"
        PaperComponent={PaperComponent}
        aria-labelledby="dialog-ultimos-envios-title"
      >
        <DialogTitle
          id="dialog-ultimos-envios-title"
          className="draggable-dialog-title"
          sx={{
            cursor: "move",
            fontWeight: 600,
          }}
        >
          Últimos envios de faturação
        </DialogTitle>

        <DialogContent dividers>
          {loadingUltimosEnvios ? (
            <MDBox py={4} display="flex" alignItems="center" justifyContent="center">
              <CircularProgress />
            </MDBox>
          ) : ultimosEnvios.length === 0 ? (
            <MDTypography variant="body2">Ainda não existem envios registados.</MDTypography>
          ) : (
            <ProjectTable
              tableKey="emails-faturacao-clientes-ultimos-envios"
              version="v1"
              columns={ultimosEnviosColumns}
              data={ultimosEnvios}
              loading={false}
              emptyMessage="Ainda não existem envios registados."
              minWidth={1200}
              maxHeight="60vh"
              defaultSortBy={[{ id: "enviadoem", desc: true }]}
            />
          )}
        </DialogContent>

        <DialogActions>
          <MDButton
            color="secondary"
            variant="outlined"
            onClick={() => setOpenUltimosEnvios(false)}
          >
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default EmailsFaturacaoClientes;
